import { lazy } from 'react';
import type { RouteObject } from 'react-router';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const StartPage = lazy(() => import('./pages/Start'));
const CpfStep = lazy(() => import('./pages/CpfStep'));
const AddressStep = lazy(() => import('./pages/AddressStep'));
const ContactsStep = lazy(() => import('./pages/ContactsStep'));
const ValidationStep = lazy(() => import('./pages/ValidationStep'));
const IdentityStep = lazy(() => import('./pages/IdentityStep'));
const TermsStep = lazy(() => import('./pages/TermsStep'));
const CompletedPage = lazy(() => import('./pages/Completed'));

/** Cadastro do paciente em 6 passos (F-01 · T-01..T-06). */
const routes: RouteObject[] = [
  { path: '/cadastro', element: <StartPage /> },
  { path: '/cadastro/cpf', element: <CpfStep /> },
  { path: '/cadastro/endereco', element: <AddressStep /> },
  { path: '/cadastro/contatos', element: <ContactsStep /> },
  { path: '/cadastro/validacao', element: <ValidationStep /> },
  { path: '/cadastro/identidade', element: <IdentityStep /> },
  { path: '/cadastro/termos', element: <TermsStep /> },
  { path: '/cadastro/concluido', element: <CompletedPage /> },
];
export default routes;
